/* eslint-disable no-unused-vars */
import React from 'react';
import { Link } from 'react-router-dom'; // Poprawiony import
import useIntersectionObserver from '../hooks/useIntersectionObserver';
import { FileText, MonitorSmartphone, MicVocal, Edit3, Globe, SearchCheck, LayoutTemplate, Building2, HeartPulse, Scale, Banknote, ShoppingCart, Megaphone, Factory, Check, Star, ShieldCheck, Users } from 'lucide-react';
import './ServicesPage.css';

const ServiceEntry = ({ icon: Icon, title, description, benefits, imagePosition = 'left', isVisible }) => (
    <div className={`service-entry ${imagePosition === 'right' ? 'icon-right' : ''} animate-on-scroll ${isVisible ? 'is-visible' : ''}`}>
        <div className="service-icon">
            <Icon size={64} strokeWidth={1.5} />
        </div>
        <div className="service-text">
            <h3>{title}</h3>
            <p>{description}</p>
            {benefits && benefits.length > 0 && (
                <ul className="service-benefits">
                    {benefits.map((benefit, index) => (
                        <li key={index}>
                            <Check size={18} className="benefit-icon" />
                            <span>{benefit}</span>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    </div>
);

function ServicesPage() {
    const [titleRef, isTitleVisible] = useIntersectionObserver();
    const [service1Ref, isService1Visible] = useIntersectionObserver();
    const [service2Ref, isService2Visible] = useIntersectionObserver();
    const [service3Ref, isService3Visible] = useIntersectionObserver();
    const [service4Ref, isService4Visible] = useIntersectionObserver();
    const [service5Ref, isService5Visible] = useIntersectionObserver();
    const [service6Ref, isService6Visible] = useIntersectionObserver();
    const [industriesRef, isIndustriesVisible] = useIntersectionObserver();
    const [qualityRef, isQualityVisible] = useIntersectionObserver();
    const [ctaEndRef, isCtaEndVisible] = useIntersectionObserver();

    return (
        <>
            <section ref={titleRef} className={`page-header-section section-bg-white animate-on-scroll ${isTitleVisible ? 'is-visible' : ''}`}>
                <div className="container text-center">
                    <h1>Poznaj nasze usługi tłumaczeniowe</h1>
                    <p className="subtitle">Dostarczamy kompleksowe rozwiązania lingwistyczne dopasowane do potrzeb Twojego biznesu, gwarantując najwyższą jakość i precyzję na każdym etapie.</p>
                </div>
            </section>

            <section ref={service1Ref} className="service-section section-bg-light-gray">
                <div className="container">
                    <ServiceEntry
                        icon={FileText}
                        title="Tłumaczenia specjalistyczne"
                        description="Realizujemy precyzyjne tłumaczenia tekstów z kluczowych dziedzin: prawniczych (umowy, akty), medycznych (badania, dokumentacja), technicznych (instrukcje, specyfikacje) oraz marketingowych (kampanie, strony WWW), zawsze z uwzględnieniem specyfiki branżowej i terminologii."
                        benefits={[
                            "Gwarancja poprawności terminologicznej",
                            "Dostosowanie do specyfiki branży",
                            "Zachowanie poufności danych",
                            "Współpraca z ekspertami dziedzinowymi"
                        ]}
                        isVisible={isService1Visible}
                        imagePosition="left"
                    />
                </div>
            </section>

            <section ref={service2Ref} className="service-section section-bg-white">
                 <div className="container">
                    <ServiceEntry
                        icon={MicVocal}
                        title="Tłumaczenia audiowizualne"
                        description="Oferujemy profesjonalne tworzenie napisów do filmów i materiałów wideo (subtitling), precyzyjne transkrypcje nagrań audio/wideo oraz przygotowanie list dialogowych pod dubbing lub lektora, dbając o synchronizację i naturalność przekazu."
                        benefits={[
                            "Idealna synchronizacja czasowa",
                            "Naturalne brzmienie dialogów",
                            "Obsługa różnych formatów plików",
                            "Tłumaczenia dla platform VOD i mediów"
                        ]}
                        isVisible={isService2Visible}
                        imagePosition="right"
                    />
                </div>
            </section>

             <section ref={service3Ref} className="service-section section-bg-light-gray">
                 <div className="container">
                    <ServiceEntry
                        icon={MonitorSmartphone}
                        title="Lokalizacja oprogramowania i stron WWW"
                        description="Dostosowujemy interfejsy użytkownika (UI), dokumentację techniczną oraz wszelkie treści Twoich aplikacji i stron internetowych, aby idealnie rezonowały z użytkownikami na rynkach zagranicznych, uwzględniając kontekst kulturowy."
                        benefits={[
                            "Poprawa User Experience (UX)",
                            "Uwzględnienie niuansów kulturowych",
                            "Integracja z procesem deweloperskim",
                            "Zwiększenie zasięgu globalnego produktu"
                        ]}
                        isVisible={isService3Visible}
                        imagePosition="left"
                    />
                </div>
            </section>

            <section ref={service4Ref} className="service-section section-bg-white">
                 <div className="container">
                    <ServiceEntry
                        icon={Edit3}
                        title="Korekta i edycja tłumaczeń (Proofreading)"
                        description="Nasi eksperci językowi weryfikują i udoskonalają istniejące tłumaczenia pod kątem błędów gramatycznych, stylistycznych, interpunkcyjnych oraz spójności terminologicznej, podnosząc ich jakość i czytelność."
                        benefits={[
                            "Eliminacja błędów językowych",
                            "Poprawa stylu i płynności tekstu",
                            "Zapewnienie spójności terminologii",
                            "Ostateczna weryfikacja przed publikacją"
                        ]}
                        isVisible={isService4Visible}
                        imagePosition="right"
                    />
                </div>
            </section>

            <section ref={service5Ref} className="service-section section-bg-light-gray">
                 <div className="container">
                    <ServiceEntry
                        icon={LayoutTemplate}
                        title="Tworzenie treści wielojęzycznych"
                        description="Pomagamy w tworzeniu angażujących treści (np. artykuły blogowe, opisy produktów, kampanie SEO) od podstaw w wielu językach lub adaptujemy istniejące materiały, zapewniając spójny wizerunek marki na rynkach globalnych."
                        benefits={[
                            "Treści zoptymalizowane pod SEO",
                            "Spójny głos marki na różnych rynkach",
                            "Angażujące materiały dla odbiorców",
                            "Wsparcie strategii content marketingowej"
                        ]}
                        isVisible={isService5Visible}
                        imagePosition="left"
                    />
                </div>
            </section>

            <section ref={service6Ref} className="service-section section-bg-white">
                 <div className="container">
                    <ServiceEntry
                        icon={SearchCheck}
                        title="Testowanie lokalizacji"
                        description="Przeprowadzamy szczegółowe testy językowe i funkcjonalne zlokalizowanych aplikacji i stron internetowych, aby upewnić się, że interfejs jest intuicyjny, tłumaczenia poprawne kontekstowo, a całość działa bezbłędnie na docelowym rynku."
                        benefits={[
                            "Wykrywanie błędów funkcjonalnych",
                            "Ocena poprawności językowej i kulturowej",
                            "Zapewnienie intuicyjności interfejsu",
                            "Gwarancja jakości produktu końcowego"
                        ]}
                        isVisible={isService6Visible}
                        imagePosition="right"
                    />
                </div>
            </section>

             <section ref={industriesRef} className={`industries-section section-bg-light-gray animate-on-scroll ${isIndustriesVisible ? 'is-visible' : ''}`}>
                <div className="container text-center">
                    <h2>Obsługiwane branże</h2>
                    <p className="subtitle">Posiadamy bogate doświadczenie w tłumaczeniach dla kluczowych sektorów rynku.</p>
                    <div className="industries-grid">
                        <div className="industry-item"><MonitorSmartphone size={32} strokeWidth={1.5}/><span>IT i Nowe Technologie</span></div>
                        <div className="industry-item"><Scale size={32} strokeWidth={1.5}/><span>Prawo i Finanse</span></div>
                        <div className="industry-item"><HeartPulse size={32} strokeWidth={1.5}/><span>Medycyna i Farmacja</span></div>
                        <div className="industry-item"><Megaphone size={32} strokeWidth={1.5}/><span>Marketing i Reklama</span></div>
                        <div className="industry-item"><ShoppingCart size={32} strokeWidth={1.5}/><span>E-commerce</span></div>
                        <div className="industry-item"><Factory size={32} strokeWidth={1.5}/><span>Przemysł i Technika</span></div>
                    </div>
                </div>
            </section>

             <section ref={qualityRef} className={`quality-section section-bg-white animate-on-scroll ${isQualityVisible ? 'is-visible' : ''}`}>
                <div className="container text-center">
                    <h2>Gwarancja jakości Lingland</h2>
                    <p className="subtitle">Nasz rygorystyczny proces zapewnia najwyższy standard każdego tłumaczenia.</p>
                    <div className="quality-steps-grid">
                        <div className="quality-step">
                            <Star size={40} strokeWidth={1.5} color="var(--color-accent)"/>
                            <h4>Selekcja tłumaczy</h4>
                            <p>Współpracujemy wyłącznie z doświadczonymi lingwistami i ekspertami branżowymi.</p>
                        </div>
                         <div className="quality-step">
                            <Edit3 size={40} strokeWidth={1.5} color="var(--color-accent)"/>
                            <h4>Weryfikacja i korekta</h4>
                            <p>Każde tłumaczenie podlega dodatkowej weryfikacji przez drugiego specjalistę (proofreading).</p>
                        </div>
                        <div className="quality-step">
                            <ShieldCheck size={40} strokeWidth={1.5} color="var(--color-accent)"/>
                            <h4>Kontrola jakości QA</h4>
                            <p>Stosujemy narzędzia CAT i procedury QA do zapewnienia spójności i poprawności.</p>
                        </div>
                        <div className="quality-step">
                            <Users size={40} strokeWidth={1.5} color="var(--color-accent)"/>
                            <h4>Native Speaker Review</h4>
                            <p>Opcjonalna weryfikacja przez rodzimego użytkownika języka gwarantuje naturalność przekazu.</p>
                        </div>
                    </div>
                </div>
            </section>

             <section className={`cta-services-end section-bg-accent animate-on-scroll ${isCtaEndVisible ? 'is-visible' : ''}`} ref={ctaEndRef}>
                 <div className="container text-center">
                    <h2>Masz konkretny projekt lub pytania?</h2>
                    <p className="subtitle">Chętnie przygotujemy indywidualną ofertę lub odpowiemy na Twoje wątpliwości.</p>
                    {/* Użycie Link, który jest teraz zaimportowany */}
                    <Link to="/kontakt" className="button-inverted">
                       Skontaktuj się z nami
                    </Link>
                 </div>
            </section>
        </>
    );
}

export default ServicesPage;